import { render, staticRenderFns } from "./SettingsList.vue?vue&type=template&id=00f028f4&scoped=true"
import script from "./SettingsList.vue?vue&type=script&lang=js"
export * from "./SettingsList.vue?vue&type=script&lang=js"
import style0 from "./SettingsList.vue?vue&type=style&index=0&id=00f028f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f028f4",
  null
  
)

export default component.exports